import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _class;
import React from "react";
import intl from "../../utils/intl";
import { BlockContainer } from "./index.style";
import SectionTitle from "../_components/SectionTitle";
import ConfigItem from "../_components/ConfigItem";
import withFormOperate from "../_components/withFormOperate";
import { getMemoizedAssets } from "./util";
var TreeSelectConfig = withFormOperate(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeSelectConfig, _React$Component);
  var _super = _createSuper(TreeSelectConfig);
  function TreeSelectConfig() {
    var _this;
    _classCallCheck(this, TreeSelectConfig);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.getSingle = getMemoizedAssets(_this.props.styleCounts.tree, "tree/tree-radio");
    _this.getMulti = getMemoizedAssets(_this.props.styleCounts.treeCheck, "tree/tree-check");
    return _this;
  }
  _createClass(TreeSelectConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        handleChange = _this$props.handleChange,
        schema = _this$props.schema;
      return /*#__PURE__*/React.createElement(BlockContainer, {
        id: "tree-select-config"
      }, /*#__PURE__*/React.createElement(SectionTitle, {
        title: "\u6811\u72B6\u9009\u62E9",
        titleTail: "TreeSelect"
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        cols: 4,
        title: intl.get("hzero.hzeroTheme.page.singleSelect").d("单选"),
        items: this.getSingle(schema),
        defaultSelected: value.tree,
        onChange: handleChange("tree")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        cols: 4,
        title: intl.get("hzero.hzeroTheme.page.multiSelect").d("多选"),
        items: this.getMulti(schema),
        onChange: handleChange("treeCheck"),
        defaultSelected: value.treeCheck
      }));
    }
  }]);
  return TreeSelectConfig;
}(React.Component)) || _class;
export { TreeSelectConfig as default };